import { Outcome } from '@eag/sales-app-base/build/app/core/Outcome';
import { ComplexContentModelType } from '@eag/sales-app-base/build/app/core/rest-api/model';
import { ComplexContentModel } from '@eag/sales-app-base/build/app/core/rest-api/model/complex-content-model';
import { contentService } from '@eag/sales-app-base/build/app/core/service/ContentService';
import React, { useEffect, useState } from 'react';
import { parseIdFromYoutubeVideoUrl } from 'utils/urlUtils';
import ArticleWithVideoComponent from './contents/ArticleWithVideoComponent';
import FaqComponent from './contents/FaqComponent';
import MultipleVideosComponent from './contents/MultipleVideosComponent';
import SimpleArticleComponent from './contents/SimpleArticleComponent';

interface Props {
	navigationNodeName: string;
}

const LoginPageContentsComponent: React.FC<Props> = (props) => {
	const { navigationNodeName } = props;
	const [outcome, setOutcome] = useState(Outcome.NONE);
	const [contents, setContents] = useState<ComplexContentModel[]>([]);

	useEffect(() => {
		contentService
			.complex(navigationNodeName)
			.then(({ data }) => {
				setContents(data);
				setOutcome(Outcome.SUCCESS);
			})
			.catch(() => {
				setOutcome(Outcome.ERROR);
			});
	}, []);

	return (
		<>
			{outcome === Outcome.SUCCESS && (
				<section className="login-page-contents">
					{contents.map((content, index) => {
						const className = content.type?.toLowerCase()?.replace(/_/g, '-') ?? '';
						const videoId = content.children?.[0].mediaUrl
							? parseIdFromYoutubeVideoUrl(content.children[0].mediaUrl)
							: undefined;

						switch (content.type) {
							case ComplexContentModelType.LOGIN_PAGE_ARTICLE_WITH_VIDEO:
								return videoId ? (
									<ArticleWithVideoComponent key={index} content={content} className={className} />
								) : (
									<SimpleArticleComponent key={index} content={content} />
								);
							case ComplexContentModelType.LOGIN_PAGE_MULTIPLE_VIDEOS:
								return <MultipleVideosComponent key={index} content={content} className={className} />;
							case ComplexContentModelType.LOGIN_PAGE_FAQ:
								return <FaqComponent key={index} content={content} className={className} />;
							default:
								return <React.Fragment key={index} />;
						}
					})}
				</section>
			)}
		</>
	);
};

export default LoginPageContentsComponent;
